export const environment = {
  production: false,
  projectName: "COMPAS",

  // // ----- Local ----------------------------------------------------------------
  // apiUrl: 'http://localhost:8080/api/salescomm/',
  // clientId: 'f57e270c-df8c-4f28-ab0b-980fadc1fb1c',
  // redirectUri: 'http://localhost:4200/'


  // ----- Local UAT ----------------------------------------------------------------
  // apiUrl: 'http://localhost:8080/api/salescomm/',
  // clientId: 'e9495166-d791-4b13-acb1-fcdd3512b144',
  // redirectUri: 'http://localhost:4250/'

  // ----- Dev -------------------------------------------------------------------------
  //  apiUrl: 'https://salescommissionrebuildbackend1-exfhn7j3kq-ue.a.run.app/api/salescomm/',
  //  clientId: 'f57e270c-df8c-4f28-ab0b-980fadc1fb1c',
  //  redirectUri: 'https://salescommissionrebuildfrontend-exfhn7j3kq-ue.a.run.app/'

  // ----- UAT----------------------------------------------------------------------
  //  apiUrl: 'https://compas-uat-backend-exfhn7j3kq-ue.a.run.app/api/salescomm/',
  //  clientId: 'fca7d133-300f-447a-af81-50710a4f5191',
  //  redirectUri: 'https://compas-uat-frontend-exfhn7j3kq-ue.a.run.app/'

  // ----- PRE PROD ---------------------------------------------------------------------
  // apiUrl: 'https://compas-pre-prod-backend-sf3kqgr7va-ue.a.run.app/api/salescomm/',
  // clientId: '348a6c85-d2e8-4929-a7e8-45d4b51c68f9',
  // redirectUri: 'https://compas-pre-prod-frontend-sf3kqgr7va-ue.a.run.app/'

  // ----- PROD ---------------------------------------------------------------------
  apiUrl: 'https://compas-prod-backend-sf3kqgr7va-ue.a.run.app/api/salescomm/',
  clientId: 'e4be09e8-98d1-4112-8389-d6d3c90d08ab',
  redirectUri: 'https://compas-prod-frontend-sf3kqgr7va-ue.a.run.app/'

  
};


